let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hlMzm")).then(() => parcelRequire('54pNf'));